<template>
  <v-list dense nav class="py-0">
    <template v-for="item in items">
      <!-- SINGLE COMPONENT -->
      <v-list-item
        v-if="item.Action && (item.Items || []).length == 0"
        :to="{name:item.Action.Page, query:$route.query}"
        :key="item.$ID"
        link
      >
        <v-list-item-icon>
          <v-icon>{{ item.Icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t(item.Caption) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- multiple nodes -->

      <v-list-group no-action v-else :key="item.$ID" :prepend-icon="item.Icon" value="true">
        <template v-slot:activator>
          <v-list-item-title>{{$t(item.Caption)}}</v-list-item-title>
        </template>

        <template v-for="subitem in item.Items">
          <!-- subitems -->
          <v-list-item
            v-if="subitem.Action && (subitem.Items || []).length == 0"
            :to="{name:subitem.Action.Page, query:$route.query}"
            :key="subitem.$ID"
            link
          >
         
            <v-list-item-content>
              <v-list-item-title>{{ $t(subitem.Caption) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            sub-group
            no-action
            v-else
            :key="subitem.$ID"
            value="true"
          >
            <template v-slot:activator>
              <v-list-item-title>{{$t(subitem.Caption)}}</v-list-item-title>
            </template>

            <template v-for="subitem2 in subitem.Items">
              <!-- subitems -->
              <v-list-item
                v-if="subitem2.Action && (subitem2.Items || []).length == 0"
                :to="{name:subitem2.Action.Page, query:$route.query}"
                :key="subitem2.$ID"
                link
              >
                <!-- <v-list-item-icon>
              <v-icon>{{ subitem.Icon }}</v-icon>
                </v-list-item-icon>-->

                <v-list-item-content>
                  <v-list-item-title>{{ $t(subitem2.Caption) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
        </template>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'NavigationMenu',
  props: ['items']
}
</script>
